/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21.6 10.2955H2.4c-1.3255 0-2.4 1.0684-2.4 2.3863v8.1818c0 1.318 1.0745 2.3864 2.4 2.3864h19.2c1.3255 0 2.4-1.0684 2.4-2.3864v-8.1818c0-1.3179-1.0745-2.3863-2.4-2.3863ZM2.4 12.3409h19.2c.1894 0 .3429.1526.3429.3409v8.1818c0 .1883-.1535.3409-.3429.3409H2.4a.3419.3419 0 0 1-.3429-.3409v-8.1818a.3419.3419 0 0 1 .3429-.3409Zm17.8286-6.8182c.568 0 1.0285.458 1.0285 1.0227 0 .5178-.3869.9457-.889 1.0134l-.1395.0094H3.7714c-.568 0-1.0285-.458-1.0285-1.0228 0-.5177.387-.9456.889-1.0133l.1395-.0094h16.4572ZM18.1714.75c.5681 0 1.0286.4579 1.0286 1.0227 0 .5178-.387.9457-.889 1.0134l-.1396.0094H5.8286c-.568 0-1.0286-.458-1.0286-1.0228 0-.5177.387-.9456.889-1.0134L5.8286.75h12.3428Z"
    clipRule="evenodd"
  />,
  'MenuImages'
);
